<!--Composant de base pour les pages HTML-->
<div class="flex w-full align-items-center justify-content-center">
  <div class="flex w-full m-width-1024 flex-column align-items-center shadow-1 back--color back--height">
    <ng-content></ng-content>
  </div>
</div>
